export default __webpack_public_path__ + "static/media/pdf.bfe6dfa4.svg";